import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const HIDE_BLOG_SITE = ['eu', 'kr', 'nl'];

export default function FixTab() {
    const { useLang, useState, useEffect, useRouter } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const [fixH, setFixH] = useState(0);
    const [activeTab, setActiveTab] = useState(0);
    const tabs: any = [
        { text: t('fix_tab1'), id: '#outdoor-recreation-B', key: 0 },
        { text: t('fix_tab2'), id: '#outdoor-recreation-D', key: 1 },
        { text: t('fix_tab3'), id: '#outdoor-recreation-L', key: 2 },
        { text: t('fix_tab4'), id: '#outdoor-recreation-M', key: 3 },
        { text: t('fix_tab5'), id: '#outdoor-recreation-N', key: 4 },
        { text: t('fix_tab6'), id: '#outdoor-recreation-O', key: 5 },
    ];
    if (HIDE_BLOG_SITE.includes(locale)) {
        tabs.splice(4, 1);
    }
    if (locale == 'kr') {
        tabs.splice(2, 1);
    }

    const handleClickTab = (k: number) => setActiveTab(k);

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    useEffect(() => {
        const resizeFunc = () => {
            const target = document.querySelector('.outdoor-recreation-fix-tab .tabs-box') as HTMLUListElement;
            target.style.transition = 'left .4s ease';
            if (target.offsetWidth > window.innerWidth && activeTab >= 3) {
                target.style.left = `${window.innerWidth - target.offsetWidth}px`;
            } else {
                target.style.left = `${0}px`;
            }
        };
        resizeFunc();
        // window.addEventListener('resize', resizeFunc);
        // return () => window.removeEventListener('resize', resizeFunc);
    }, [activeTab]);

    useEffect(() => {
        const targetB = document.querySelector('#outdoor-recreation-B') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '#outdoor-recreation-B',
            triggerHook: 1,
            offset: '50%',
            duration: targetB?.offsetHeight,
            onEnter: () => setActiveTab(0),
        });
        const targetD = document.querySelector('#outdoor-recreation-D') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '#outdoor-recreation-D',
            triggerHook: 1,
            offset: '50%',
            duration: targetD?.offsetHeight,
            onEnter: () => setActiveTab(1),
        });
        if (!['kr'].includes(locale)) {
            const targetL = document.querySelector('#outdoor-recreation-L') as HTMLDivElement;
            AniContainer.create({
                triggerElement: '#outdoor-recreation-L',
                triggerHook: 1,
                offset: '50%',
                duration: targetL?.offsetHeight,
                onEnter: () => setActiveTab(2),
            });
        }
        const targetM = document.querySelector('#outdoor-recreation-M') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '#outdoor-recreation-M',
            triggerHook: 1,
            offset: '50%',
            duration: targetM?.offsetHeight,
            onEnter: () => setActiveTab(3),
        });
        if (!HIDE_BLOG_SITE.includes(locale)) {
            const targetN = document.querySelector('#outdoor-recreation-N') as HTMLDivElement;
            AniContainer.create({
                triggerElement: '#outdoor-recreation-N',
                triggerHook: 1,
                offset: '50%',
                duration: targetN?.offsetHeight,
                onEnter: () => setActiveTab(4),
            });
        }
        AniContainer.create({
            triggerElement: '#outdoor-recreation-O',
            triggerHook: 1,
            offset: '50%',
            onEnter: () => setActiveTab(5),
        });
        setTimeout(() => {
            const bar = document.querySelector('.announcement-bar') as HTMLElement;
            if (bar) {
                const styles = window.getComputedStyle(bar);
                const position = styles.position;
                setFixH(Number(position === 'sticky' ? bar?.offsetHeight : 0) || 0);
            }
        }, 3000);
    }, []);

    return (
        <div className={`outdoor-recreation-fix-tab ${css['outdoor-recreation-fix-tab']}`} style={{ top: `${fixH}px` }}>
            <div className="tabs-wrapper">
                <ul className="tabs-box" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                    {tabs?.map((tab: any) => (
                        <a className={`tab ${activeTab == tab?.key ? 'active' : ''}`} href={tab?.id} key={tab?.key} onClick={() => handleClickTab(tab?.key)}>
                            {tab?.text}
                        </a>
                    ))}
                </ul>
            </div>
        </div>
    );
}
